<div class="flex flex-row justify-center">
  <div class="w-4on5 md-w-full">
    <div class="app-container">
      <h2>{{ element !== undefined ? element.name : 'Application Name' }}</h2>
      <mat-form-field appearance="fill">
        <mat-label>Catalog of functions </mat-label>
        <mat-select placeholder="Choose a function">
          <mat-option (click)="openImportFileCsvConfig()"> Import a file CSV</mat-option>

          <mat-option (click)="openConfigXlsx()"> Import a file xlsx </mat-option>
          <!-- <mat-option (click)="onLunchScript()">Run a script</mat-option> -->
          <!-- <mat-option (click)="onUpdateConnection(null)"> DB Configuration </mat-option> -->

          <mat-option (click)="onUpdateController(null)">Controllers</mat-option>
          <mat-option (click)="onConfigGroupingFunction()"> Creat a group </mat-option>
          <mat-option (click)="onOpenTableVisualizationConfig()"> Visualization Table </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="ControllersAndConnections">
      <mat-form-field class="toto" appearance="fill" emptyPlaceholder="No data found">
        <mat-label>Controllers</mat-label>
        <mat-select placeholder="Column type">
          @for (item of controllers; track item.id) {
          <mat-option (click)="onUpdateController(item)" value="{{ item.id }}">{{ item.name !== null ? item.name : 'toto' }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (functions.length !== 0) {
    <mat-accordion>
      <h6>Import File Csv</h6>
      @for (function of functions; track function.id) {
      <div>
        <mic-app-import-file [func]="function"></mic-app-import-file>
      </div>
      }
    </mat-accordion>
    } @else {
    <mic-empty-state icon="layers_clear" title="There is no Function to display." subtitle="You can use the button above to add a new one!">
    </mic-empty-state>
    } @if (xlsxFunctions.length !== 0) {
    <mat-accordion>
      <h6>Import File Xlsx</h6>
      @for (xlsxFunction of xlsxFunctions; track xlsxFunction.id) {
      <div>
        <mic-app-import-file-xlsx [xlsxFunction]="xlsxFunction"></mic-app-import-file-xlsx>
      </div>
      }
    </mat-accordion>
    } @if (tableVisualizations.length !== 0) {
    <mat-accordion>
      <h6>display the table</h6>
      @for (table of tableVisualizations; track table.id) {
      <div>
        <mic-app-table-visualization (childToParent)="updateParentData($event)" [func]="table"></mic-app-table-visualization>
      </div>
      }
    </mat-accordion>
    }

    <!-- <ng-container *ngIf="scripts.length !== 0">
    <mat-accordion>
      <h6>Run Script</h6>
      <div *ngFor="let scriptElement of scripts">
        <mic-app-run-script-element [script]="scriptElement"></mic-app-run-script-element>
      </div>
    </mat-accordion>
  </ng-container> -->
  </div>
</div>

<footer>
  <mic-alert-center></mic-alert-center>
</footer>
